<template>
  <div v-if="showFirstFields">
    <div class="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="form-offcanvasLabel" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content model-shadow">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalToggleLabel">{{ systemServices.name }}</h5>
            <input type="hidden" v-model="serviceType" id="serviceType" />
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            <input type="hidden" v-model="serviceId" id="serviceId" />
          </div>
          <div class="position-relative">
            <div class="progress" style="height: 2px">
              <div class="progress-bar" role="progressbar" :style="{ width: '25%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="num-text">
              <p><span class="num1">1</span>/4</p>
            </div>
          </div>
          <div class="modal-body">
            <div>
              <p class="modal-text">Select Required {{ systemServices.name }} Date *</p>
              <div>
                <p class="mb-3">Which dates do you need?</p>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="position-relative">
                      <InputField class="form-control form--control con p-0" type="date" v-model="fromDate" :error-message="errors['fromDate']" :error-messages="errorMessages['fromDate']"></InputField>
                      <button class="footer-news1"><img src="" alt="" /></button>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="position-relative">
                      <InputField class="form-control form--control con p-0" type="date" v-model="toDate" :error-message="errors['toDate']" :error-messages="errorMessages['toDate']"></InputField>
                      <button class="footer-news1"><img src="" alt="" /></button>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <p class="mb-0">Which times do you needs?</p>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="position-relative">
                      <InputField type="time" class="form-control form--control con p-0" placeholder="" v-model="fromTime" :error-message="errors['fromTime']" :error-messages="errorMessages['fromTime']"></InputField>
                      <button class="footer-news"><img src="" alt="" /></button>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="position-relative">
                      <InputField type="time" class="form-control form--control con p-0" placeholder="" v-model="toTime" :error-message="errors['toTime']" :error-messages="errorMessages['toTime']"></InputField>
                      <button class="footer-news"><img src="" alt="" /></button>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <p class="modal-text mb-2">Extra Add-ons (Optional)</p>
                <p>Add More Items to the Basic package</p>
                <div class="extra-border">
                  <p class="">Do you need pet pickup Service?</p>
                  <label class="radio-inline me-4"> <input type="radio" name="optradio" class="me-3 radio-btn" value="yes" v-model="petPickup" />Yes </label>
                  <label class="radio-inline me-4"> <input type="radio" name="optradio" class="me-3" value="no" v-model="petPickup" />No </label>
                  <p class="mt-3">Additional Notes</p>
                  <textarea name="message" id="pickup-additional-notes" cols="30" rows="10" class="form-control popup-textarea" placeholder="Your Message" required v-model="additionalNotes"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="handleBookingDetails1" id="one">
              <span>Continue</span>
              <span><img src="/images/icon14.png" alt="" width="20" /></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div v-if="hideSecondModal">
        <div class="modal fade" id="exampleModalToggle2" aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel2" tabindex="-1" ref="myModal">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content model-shadow">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalToggleLabel">Add Your Details</h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                    </div>
                    <div class="position-relative">
                        <div class="progress" style="height: 2px;">
                            <div class="progress-bar" role="progressbar" style="width: 50%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="num-text">
                            <p> <span class="num1">2</span>/4</p>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div>
                            <p class="modal-text">Select Required Boarding Date *</p>
                            <div class="pop-up-label">
                                <Label>Full Name*</Label>
                                <div class="form-group">
                                    <InputField type="text" class="form-control form--control con"  placeholder="Enter Your Name" v-model="name" :error-message="errors['name']" :error-messages="errorMessages['name']"></InputField>
                                </div>
                                <Label>Phone Number*</Label>
                                <div class="form-group">
                                    <InputField type="number" class="form-control form--control con"  placeholder="Enter Your Phone Number" v-model="phone" :error-message="errors['phone']" :error-messages="errorMessages['phone']"></InputField>
                                </div>
                                <Label>Email*</Label>
                                <div class="form-group">
                                    <InputField type="email" class="form-control form--control con"  placeholder="Enter Your Email" v-model="email" :error-message="errors['email']" :error-messages="errorMessages['email']"></InputField>
                                </div>
                                <Label>Enter the address  for the service*</Label>
                                <div class="form-group">
                                    <input type="text" id="address" name="name" class="form-control" placeholder="Enter Your Address"></div>
                            </div>

                        </div>
                    </div>
                    <div class="btn-space">
                        <div class="modal-footer">
                            <button class="btn btn-primary backbtn" data-bs-target="#exampleModalToggle" data-bs-toggle="modal" data-bs-dismiss="modal"><img src="\rc-pet\public\images\icon12.png" alt="image" width="20" class="me-5">Back</button>

                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary"
                                @click ="handleSecondSubmit" >Continue<span>
                                    <img src="{{asset('images/icon14.png')}}" alt="" width="20"></span>
                                </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>   -->
  <!-- <div v-if="hideThirdModal">
        <div class="modal fade" id="exampleModalToggle3" aria-hidden="true"
            aria-labelledby="exampleModalToggleLabel3" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content model-shadow">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalToggleLabe3">Add Your Pet Details</h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                    </div>
                    <div class="position-relative">
                        <div class="progress" style="height: 2px;">
                            <div class="progress-bar" role="progressbar" style="width: 75%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="num-text">
                            <p> <span class="num1">3</span>/4</p>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div>
                            <p class="modal-text">Select Required Boarding Date *</p>
                            <div class="">
                                <p class="type-pet-text mb-2">Type of Pet</p>

                                <label class="radio-inline2 me-4">
                                    <input type="radio" name="optradio" id="typeOfPet" class="me-3 radio-btn" value="dog" v-model="typeOfPet">Dog
                                </label>
                                <label class="radio-inline2 me-4">
                                    <input type="radio" name="optradio" id="typeOfPet" class="me-3 radio-btn" value="cat" >Cat
                                </label>
                                <label class="radio-inline2 me-4">
                                    <input type="radio" name="optradio" id="typeOfPet" class="me-3 radio-btn" value="other" >Other
                                </label>
                            </div>

                            <div class="row">
                                <div class="col-lg-6">
                                    <Label class="type-pet-text mt-3">Pet Name*</Label>

                                    <ErrorMessage name="name" class="error" />
                                    <div class="form-group"> <input type="text" id="petName" name="name" v-model="petName" class="form-control" placeholder="Enter Your Name"></div>
                                </div>
                                <div class="col-lg-6">
                                    <Label class="type-pet-text mt-3">Breed*</Label>
                                    <select name="" id="breed" class="form-control mb-3" required="" v-model="breed">
                                        <option value="" selected="" disabled="">Affenpinscher</option>
                                        <option value="1">Day boarding</option>
                                        <option value="2">Day boarding</option>
                                    </select>
                                </div>
                            </div>

                            <div class="">
                                <p class="type-pet-text mb-2">Gender*</p>

                                <label class="radio-inline2 me-4">
                                    <input type="radio" id="gender" name="optradio" class="me-3 radio-btn" value="male" v-model="gender">Male
                                </label>
                                <label class="radio-inline2 me-4 female-radio">
                                    <input type="radio" id="gender" name="optradio" class="me-3 radio-btn" value="female" v-model="gender">Female
                                </label>
                            </div>

                            <div>
                                <Label class="type-pet-text mt-3">Date of Birth*</Label>
                                <input type="date" onfocus="this.showPicker()" required=""  class="form-control form--control con" placeholder="01-03-2023" name="" min="" value="" id="dob">
                            </div>

                            <div class="">
                                <Label class="type-pet-text mt-3">Size</Label>
                                <select name="" id="size" class="form-control mb-3" required="" v-model="size">
                                    <option value="1kg-5kg" selected="" disabled="">1kg - 5kg</option>
                                    <option value="5kg-10kg">5kg-10kg</option>
                                    <option value="10kg-15kg">10kg-15kg</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="btn-space">
                        <div class="modal-footer">
                            <button class="btn btn-primary backbtn" data-bs-target="#exampleModalToggle2" data-bs-toggle="modal" data-bs-dismiss="modal"><img src="\rc-pet\public\images\icon12.png" alt="image" width="20" class="me-5">Back</button>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary" @click="handleThird">Continue<span><img src="{{asset('images/icon14.png')}}" alt="" width="20"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="hideFourthModal">
        <div class="modal fade" id="exampleModalToggle4" aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel4" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content model-shadow">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalToggleLabe4">Select a Package</h5>

                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                    </div>
                    <div class="position-relative">
                        <div class="progress" style="height: 2px;">
                            <div class="progress-bar" role="progressbar" style="width: 100%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div class="num-text">
                            <p> <span class="num1">4</span>/4</p>
                        </div>
                    </div>
                    <div class="modal-body modal-4">
                        <div>
                            <label class="radio-inline3 me-4">
                                <input type="radio" name="optradio" id="package" class="radio-btns" value="basic_offerings">Basic Offerings
                            </label>

                            <div class="per-day-text">
                                <p>Included services (per pet per day)</p>
                                <p class="per-day-text"><span class="rupee-text">₹765 /</span> Per day</p>
                            </div>
                            <div class="dropdown">
                                <button class="dropdown-toggle drop-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    See All Benifits
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="#">Basic Offerings</a></li>
                                    <li><a class="dropdown-item" href="#">Standard Offerings</a></li>
                                    <li><a class="dropdown-item" href="#">Primium Offerings</a></li>
                                </ul>
                            </div>

                        </div>
                    </div>
                    <div class="modal-body modal-4 mt-4">
                        <div>
                            <label class="radio-inline3 me-4">
                                <input type="radio"    class="radio-btns" value="standard_offerings">Standard Offerings
                            </label>

                            <div class="per-day-text">
                                <p>Included services (per pet per day)</p>
                                <p class="per-day-text"><span class="rupee-text">₹856 /</span> Per day</p>
                            </div>
                            <div class="dropdown">
                                <button class="dropdown-toggle drop-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    See All Benifits
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="#">Basic Offerings</a></li>
                                    <li><a class="dropdown-item" href="#">Standard Offerings</a></li>
                                    <li><a class="dropdown-item" href="#">Primium Offerings</a></li>
                                </ul>
                            </div>

                        </div>
                    </div>
                    <div class="modal-body modal-4 mt-4 mb-5">
                        <div>
                            <label class="radio-inline3 me-4">
                                <input type="radio" name="optradio" id="package" class="radio-btns" value="premium_offerings">Primium Offerings
                            </label>

                            <div class="per-day-text">
                                <p>Included services (per pet per day)</p>
                                <p class="per-day-text"><span class="rupee-text">₹983 /</span> Per day</p>
                            </div>
                            <div class="dropdown">
                                <button class="dropdown-toggle drop-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    See All Benifits
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="#">Basic Offerings</a></li>
                                    <li><a class="dropdown-item" href="#">Standard Offerings</a></li>
                                    <li><a class="dropdown-item" href="#">Primium Offerings</a></li>
                                </ul>
                            </div>

                        </div>
                    </div>
                    <div class="btn-space">
                        <div class="modal-footer">
                            <button class="btn btn-primary backbtn" data-bs-target="#exampleModalToggle3" data-bs-toggle="modal" data-bs-dismiss="modal">
                                <img src="\rc-pet\public\images\icon12.png" alt="image" width="20" class="me-5">Back</button>

                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary" @click="handleFourth">Continue<span>
                                    <img src="{{asset('images/icon14.png')}}" alt="" width="20"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="modal fade" id="exampleModalToggle5" aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel5" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content model-shadow">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalToggleLabe5">Booking Summary</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body modal-5">
                    <div>
                        <p class="type-pet-text mb-2">Boarding Required Date</p>
                        <p>01-03-2023 | 06:00PM to 04-03-2023</p>
                    </div>
                    <div>
                        <p class="type-pet-text mb-2">Do you need pet pickup Service?</p>
                        <p>Yes</p>
                    </div>

                    <div>
                        <p class="type-pet-text mb-2">Additional Notes</p>
                        <textarea name="message"  id="additionalNotes" cols="30" rows="10" class="form-control popup-textarea" placeholder="Your Message" required="required"></textarea>
                    </div>

                </div>

                <div class="modal-body modal-5 mt-4">
                    <div class="row">
                        <div class="col-6">
                            <div>
                                <p class="type-pet-text p-0 mb-1">Pet Name</p>
                                <p>Goggy</p>
                            </div>
                            <div>
                                <p class="type-pet-text p-0 mb-1">Breed</p>
                                <p>Affenpinscher</p>
                            </div>
                            <div>
                                <p class="type-pet-text p-0 mb-1">Date of Birth</p>
                                <p class="mb-0">01-02-2023</p>
                            </div>
                        </div>
                        <div class="col-6">
                            <div>
                                <p class="type-pet-text p-0 mb-1">Type of Pet</p>
                                <p>Dog</p>
                            </div>
                            <div>
                                <p class="type-pet-text p-0 mb-1">Gender</p>
                                <p>Male</p>
                            </div>
                            <div>
                                <p class="type-pet-text p-0 mb-1">Size</p>
                                <p class="mb-0">1kg - 5kg</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-body modal-5 maodal-basic mt-4">
                    <div class="modal-5-sec">
                        <div>
                            <p class="basic-head">Basic Offerings</p>
                            <p class="in-ser-text">Included services (per pet per day)</p>
                        </div>
                        <div>
                            <p class=""><span class="rupee-text">₹983 /</span> Per day</p>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-primary" @click="checkout">Checkout<span>
                            <img src="{{asset('images/icon14.png')}}" alt="" width="20"></span>
                    </button>

                </div>

            </div>
        </div>
    </div> -->
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import axios from 'axios'
import InputField from '@/vue/components/form-elements/InputField.vue'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'

const props = defineProps(['systemServiceName'])
const errorMessages = ref({})
console.log('serName', props.systemServiceName)

const systemServices = ref({
  name: props.systemServiceName
})
const myModal = ref(null)
const showFirstFields = ref(true)
const showSecondFields = ref(false)
const showSecondModal = ref(false)
const hideSecondModal = ref(true)
const hideThirdModal = ref(true)
const hideFourthModal = ref(true)
const defaultData = () => {
  errorMessages.value = {}
  return {
    fromDate: '',
    toDate: '',
    fromTime: '',
    toTime: '',
    name: '',
    phone: '',
    email: ''
  }
}
const setFormData = (data) => {
  resetForm({
    values: {
      fromDate: data.fromDate,
      toDate: data.toDate,
      fromTime: data.fromTime,
      toTime: data.toTime,
      name: data.name,
      phone: data.phone,
      email: data.email
    }
  })
}

const validationSchema = yup.object({
  fromDate: yup.string().required('From Date is a required field'),
  toDate: yup.string().required('To Date is a required field'),
  fromTime: yup.string().required('From Time is a required field'),
  toTime: yup.string().required('To Time is a required field')
})

const { handleSubmit, errors, resetForm } = useForm({
  validationSchema
})

const { value: fromDate } = useField('fromDate')
const { value: toDate } = useField('toDate')
const { value: fromTime } = useField('fromTime')
const { value: toTime } = useField('toTime')
const { value: name } = useField('name')
const { value: phone } = useField('phone')
const { value: email } = useField('email')

const handleBookingDetails1 = handleSubmit(async () => {
  try {
    await validationSchema.validate({
      fromDate: fromDate.value,
      toDate: toDate.value,
      fromTime: fromTime.value,
      toTime: toTime.value
    })
    console.log('fromDate', fromDate.value)
    console.log('toDate', toDate.value)
    console.log('fromTime', fromTime.value)
    document.getElementById('from-date').value = fromDate.value
    document.getElementById('to-date').value = toDate.value
    document.getElementById('from-time').value = fromTime.value
    document.getElementById('to-time').value = toTime.value
    showSecondFields.value = true
    showFirstFields.value = false
    showSecondModal.value = true
    const secModal = document.getElementById('exampleModalToggle2')
    const modal = new bootstrap.Modal(secModal)
    modal.show()
  } catch (validationErrors) {
    errorMessages.value = validationErrors.errors
  }
})
const newValidationSchema = yup.object({
  name: yup.string().required('Name is a required field'),
  phone: yup.string().required('Phone is a required field'),
  email: yup.string().email('Invalid email').required('Email is a required field')
  // Add validation rules for other new fields if needed
})
const { handleSubmit: handleSecondValidation, errors: secondErrors } = useForm({
  validationSchema: newValidationSchema
})

const handleSecondSubmit = async () => {
  // alert("cgjfg")
  try {
    await handleSecondValidation()
    // Validate the new fields
    //    await newValidationSchema.validate({
    //        name: name.value,
    //         phone: phone.value,
    //         email: email.value,

    //     });

    console.log('name', name.value)
    console.log('phone', phone.value)
    console.log('email', email.value)
    hideSecondModal.value = false
    const thirdModal = document.getElementById('exampleModalToggle3')
    const modal = new bootstrap.Modal(thirdModal)
    modal.show()

    // If validation succeeds, perform any necessary actions
    // You can submit the form or perform other actions here
  } catch (validationErrors) {
    errorMessages.value = validationErrors.errors
    console.log('errr', errorMessages.value)
    console.log('error', validationErrors)
    // Handle validation errors for the new fields
    // You can display error messages or perform other actions here
  }
}
const { value: typeOfPet } = useField('typeOfPet')
const { value: petName } = useField('petName')
const { value: breed } = useField('breed')
const { value: gender } = useField('gender')
const { value: dob } = useField('dob')
const { value: size } = useField('size')
const handleThird = async () => {
  hideThirdModal.value = false
  const fourthModal = document.getElementById('exampleModalToggle4')
  const modal = new bootstrap.Modal(fourthModal)
  modal.show()
}
// const {value: package} = useField('package')
const handleFourth = async () => {
  hideFourthModal.value = false
  const fithModal = document.getElementById('exampleModalToggle5')
  const modal = new bootstrap.Modal(fithModal)
  modal.show()
}
const { value: finalAdditionalNotes } = useField('finalAdditionalNotes')

const checkout = async () => {
  const bookNowRoute = document.getElementById('bookNowRoute')
  const serviceId = document.getElementById('serviceId')
  const serviceName = document.getElementById('serviceName')
  const response = await axios.post(bookNowRoute.value, {
    fromDate: fromDate.value,
    toDate: toDate.value,
    fromTime: fromTime.value,
    toTime: toTime.value,
    name: name.value,
    phone: phone.value,
    email: email.value,
    typeOfPet: typeOfPet.value,
    petName: petName.value,
    breed: breed.value,
    gender: gender.value,
    dob: dob.value,
    size: size.value,
    serviceId: serviceId.value,
    serviceName: serviceName.value,
    // package: package.value,
    finalAdditionalNotes: finalAdditionalNotes.value
  })
}
</script>
<style scoped></style>
